module.exports = __webpack_public_path__ + "static/img/14000402.1ba3d4e1.png";